module.exports = __webpack_public_path__ + "static/media/pgm-46-anos.eded0814.webp";